import modelBaseV2 from "../../model-base-v2.model"

/**
 * Menu Hierarchy Model
 * 
 * Contains all API Request used by Model Hierarchy
 * 
 * @author Darrus Goh
 */
const MenuHierarchyModel = {
    getMenuHierarchy: (systemType) => {
        const queryString = modelBaseV2.toQueryString({ systemType });
        return modelBaseV2.get(`/api/menu?${queryString}`);
    },

    getMenu: (menuId) => {
        const params = {
            menuId
        };

        return modelBaseV2.get('/api/menu/:menuId', { params });
    },

    addMenu: (body) => {
        return modelBaseV2.post('/api/menu', { body })
    },

    updateMenu: (details) => {
        const params = {
            menuId: details.menuId
        };

        return modelBaseV2.post('/api/menu/:menuId', { body: details, params });
    }
}

export default MenuHierarchyModel;